<script setup lang="ts">
import './assets/style.scss'
import LanguageSelect from '@/entities/Language'
import { computed } from 'vue'
import { DateTime } from 'ts-luxon'
import { VNotification } from '@/shared/ui'

const year = computed(() => DateTime.now().year)
</script>

<template>
  <VNotification />

  <div class="error-layout">
    <div class="error-layout__header">
      <LanguageSelect />
    </div>

    <div class="error-layout__content">
      <slot />
    </div>

    <div class="error-layout__footer">© 2000 - {{ year }} Unilight</div>
  </div>
</template>
